<ft-subscriptions-products-iii-modal
  [apiUrl]="apiUrl"
></ft-subscriptions-products-iii-modal>
<ft-subscriptions-preferences-modal
  [apiUrl]="apiUrl"
></ft-subscriptions-preferences-modal>
<div class="subscription-products__navigation">
  <div edsRow>
    <div class="subscription-products__options">
      <div class="subscription-products__options-headers">
        <div edsRow>
          <div class="subscription-products__header">
            <div class="subscription-products__header-title">
              {{ "subscriptions.products-header-title" | translate }}
            </div>
          </div>
          <div class="subscription-products__counting">
            <span>
              {{ "subscriptions.counting-shows" | translate }}
            </span>
            <!-- Spinner -->
            <span
              class="subscription-products__loader"
              [class.subscription-products__loader--disabled]="!isLoading"
            >
              <ngx-spinner
                name="countLoadingSpinner"
                bdColor="rgba(0,0,0,0)"
                size="small"
                color="#000"
                type="line-scale-party"
                [fullScreen]="false"
              >
              </ngx-spinner>
            </span>
            <span *ngIf="!isLoading">
              <span class="subscription-products__counting-number">{{
                records.showed
              }}</span>
              <span>
                {{ "subscriptions.counting-of" | translate }}
              </span>
              <span class="subscription-products__counting-number">{{
                records.all
              }}</span>
              <span
                *ngIf="resetFilterButton"
                class="subscription-products__reset-filters"
              >
                <eds-link-item
                  edsFlexbox
                  justifyContent="flex-end"
                  theme="basic"
                  [title]="'subscriptions.reset-filters' | translate"
                  [hasIcon]="true"
                  type="reset"
                  (click)="resetFilters($event)"
                  class="text-primary"
                ></eds-link-item>
              </span>
            </span>
          </div>
        </div>
        <div
          edsRow
          class="subscription-products__preferences"
          *ngIf="(!globalUnsubscribe && loggedIn) || isLoading"
        >
          <button
            *ngIf="!isLoading"
            type="button"
            class="subscription-products__preferences-link"
            (click)="openPreferences($event)"
          >
            {{ "subscriptions.products-header-preferences" | translate }}
          </button>
        </div>
      </div>
      <div class="subscription-products__options-filters">
        <!-- Product type filters -->
        <ng-container>
          <ng-container
            *ngIf="productTypeFilter.options.length > 0 && !isLoading"
          >
            <eds-dropdown
              edsCol
              edsSpacing="md"
              ariaLabel="Dropdown"
              [ngClass]="'subscription-products__options-filter'"
              [columnNumbers]="{ s: 4, m: 3, l: 2 }"
              [theme]="'dark'"
              [label]="
                'subscriptions.filter-' + productTypeFilter.label | translate
              "
              [titleText]="' '"
              [items]="productTypeFilter.options"
              [required]="false"
              [multi]="productTypeFilter?.type?.key !== 'PRODUCTS'"
              [showCount]="true"
              [alignment]="'left'"
              [preselectedValue]="productTypeFilter.preSelectedValues"
              [selectedText]="'subscriptions.filter-selected' | translate"
              (dropdownChange)="updateProductTypeFilter($event)"
              eventType="form_filter"
            ></eds-dropdown>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div
    edsRow
    *ngIf="rowData && ((!globalUnsubscribe && loggedIn) || !isLoading)"
    class="subscription-products__filter"
    [class.subscription-products__filter--disabled]="isLoading"
  >
    <!-- Search -->
    <ng-container>
      <eds-search
        *ngIf="rowData"
        edsCol
        edsSpacing="md"
        [columnNumbers]="{ s: '4', m: 'auto', l: 'auto' }"
        placeholder="{{ 'subscriptions.filter-search' | translate }} {{
          productTypeFilter.preSelectedValues['label']
        }}"
        fieldId="search__field"
        [value]="textFilterValue"
        (searchTerm)="searchByKeyword($event)"
      ></eds-search>
    </ng-container>
    <div *ngIf="rowData" class="subscription-products__sorting-toggles-box">
      <div class="subscription-products__sorting-toggle">
        <span>{{ "subscriptions.show-subscriptions-only" | translate }}</span>
        <eds-switch
          [switchId]="'show-subscriptions-only'"
          labelOff="{{ 'subscriptions.off' | translate }}"
          labelOn="{{ 'subscriptions.on' | translate }}"
          class="subscription-products__filter-switch"
          [class.subscription-products__filter-switch--disabled]="isLoading"
          [state]="subscriptionOnlyState"
          (switchPressed)="toggleSubscriptionsOnly($event)"
        ></eds-switch>
      </div>
    </div>
  </div>
  <!-- Other filter(s) -->
  <div
    class="subscription-products__other-filters"
    [class.subscription-products__other-filters--disabled]="isLoading"
  >
    <eds-accordion theme="basic" *ngIf="isAnyFilterPresent">
      <eds-accordion-item
        [noPadding]="true"
        [hideBorder]="true"
        [title]="'subscriptions.products-header-filters' | translate"
      >
        <div edsSubGrid="layout-5">
          <ng-container *ngFor="let filterType of otherFilterTypes">
            <!-- Other filter(s) -->
            <eds-dropdown
              edsSpacing="md"
              [style.whiteSpace]="'nowrap'"
              [attr.aria-label]="filterType.filterName"
              [id]="filterType.filterName"
              name="drop-down"
              [multi]="true"
              [items]="filterType.filterItems"
              [label]="filterType.filterName"
              [titleText]="'subscriptions.select-to-filter' | translate"
              [selectedText]="'subscriptions.filter-selected' | translate"
              (dropdownChange)="onDropdownChange(filterType.filterName, $event)"
              #filterDropdowns
            ></eds-dropdown>
          </ng-container>
        </div>
      </eds-accordion-item>
    </eds-accordion>
  </div>
</div>
<div edsRow *ngIf="!loggedIn" class="subscription-products__global-unsubscribe">
  {{ "subscriptions.login-note" | translate }}
</div>
<div
  edsRow
  *ngIf="globalUnsubscribe && !isLoading"
  class="subscription-products__global-unsubscribe"
>
  {{ "subscriptions.global-unsubscribe-note" | translate }}
</div>
<!-- Listing section -->
<div edsRow>
  <div edsCol>
    <eds-dynamic-table
      *ngIf="isPopulated"
      class="subscription-products__dynamic-table"
      [class.subscription-products__dynamic-table--disabled]="isLoading"
      [colDefs]="colDefs"
      idCol="productId"
      [rowTemplate]="customProductsRowTemplate"
      [mobileTemplate]="customProductsRowTemplate"
      [rowData]="rowData"
      [showPagination]="true"
      tableTheme="secondary"
      [pageSize]="25"
      [pageSizeOptions]="[25, 50, 75, 100]"
      [cardBreakpoint]="FrkBreakpoint.Tablet"
      [hasCheckboxColumn]="false"
      [hasStickyHeader]="true"
      [hasBorders]="true"
      [labelNoMatchingData]="'subscriptions.no-data' | translate"
      [labelDropdown]="'subscriptions.items-per-page' | translate"
      [labelDropdownAria]="'subscriptions.items-per-page' | translate"
    ></eds-dynamic-table>
    <!-- custom template used for generating table rows -->
    <ng-template
      let-item
      let-callback="checkboxCallback"
      #customProductsRowTemplate
    >
      <ft-subscriptions-products-iii-row
        [rowData]="item"
        [apiUrl]="apiUrl"
      ></ft-subscriptions-products-iii-row>
    </ng-template>
  </div>
</div>
